<div class="top-header-area">
    <!-- <div id="google_translate_element"></div> -->
    <nav class="navbar navbar-expand-md top-manubar">
        <button class="navbar-toggler" (click)="onToggle()" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
            <span class="navbar-toggler-icon barIcon h-auto"><i class="ti-menu"></i></span>
        </button>
        <a class="navbar-brand" routerLink="/">
            <img src="assets/images/propira-logo.webp" alt="Propira Logo" class="img-fluid" loading="lazy">
            <img src="assets/images/mobile-logo.png" alt="Propira Logo" class="img-fluid mobile-view" loading="lazy">
        </a>
        <!-- <a class="navbar-brand newservices-btn" routerLink="/facilities-for-property">
            <p>Facilities for Property</p>
        </a> -->

        <div class="collapse navbar-collapse mobilemenu" id="collapsibleNavbar">
            <ul class="navbar-nav menu-listing ml-auto">
                <li class="nav-item">
                    <a class="nav-link only-link" href="mailto:support@propira.com" style="cursor:pointer"><i
                            class="ti-email"></i> support@propira.com</a>
                </li>
                <!--
                <li class="nav-item">
                    <a class="nav-link only-link" href="tel:+919116683232" style="cursor:pointer"><i class="ti-mobile"></i> +91 9116683232 </a>
                </li>
                -->
                <li class="nav-item" style="display: none">
                    <a class="nav-link feedback-link" style="cursor:pointer"> Feedback</a>
                </li>
                <li class="nav-item post-property">
                    <a class="nav-link" (click)="postProperty()" style="cursor:pointer" routerLink="/quick-listing"><i class="ti-pencil-alt"></i>
                        Post Your Property
                        <span class="menu-offer">FREE</span>
                    </a>
                </li>
                <li class="nav-item dropdown" *ngIf="isLoggedIn()">
                    <a class="nav-link" data-toggle="dropdown" href="javascript:void(0)" style="text-transform: capitalize;"><i class="ti-user"></i> Welcome {{ profileDetail.name }}, My
                        Account <i class="ti-angle-down"></i></a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" routerLink="/profile">My Profile</a>
                        <a class="dropdown-item" (click)="logout()" style="cursor:pointer">
                            Logout</a>
                    </div>
                </li>
                <li class="nav-item" *ngIf="!isLoggedIn()">
                    <a class="nav-link" href="javascript:void(0)" (click)="resetSignLoginForm();openLoginWindow();signIn()"><i
                            class="ti-user"></i> Sign Up/Login
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</div>

<div class="modal fade" id="loginModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="limiter">
                <div class="container-login100" id="flipper">
                    <div class="wrap-login100 front">
                        <button type="button" class="close-one" data-dismiss="modal"><i class="ti-close"></i></button>
                        <div>
                            <div class="login100-pic js-tilt" data-tilt>
                                <img src="assets/images/propira-login.png" loading="lazy" alt="login image">
                            </div>
                            <p>New to Propira? <a href="javascript:void(0)" id="registerButton" (click)="resetSignLoginForm()">Sign
                                    Up</a></p>
                        </div>
                        <form class="login100-form validate-form" name="check_login" id="check_login" method="post" (ngSubmit)="chkLogin()" #check_login="ngForm" style="position:relative" *ngIf="loginForm">
                            <div class="loader" *ngIf="loginLoader">
                                <img class="img-fluid" src="assets/images/loader.gif" loading="lazy" alt="loader image">
                            </div>
                            <span class="login100-form-title">Login</span>
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="loginErrorMsg"><i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="loginErrorMsg"></span></p>
                            <p style="font-size: 14px;color:green;font-weight:300;text-align:center" *ngIf="loginSuccMsg"><i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHTML]="loginSuccMsg"></span></p>
                            <div class="wrap-input100 validate-input" data-validate="Valid email is required">
                                <input class="input100 loginfocus" type="text" name="email_mobile" placeholder="Enter Email/Mobile" required id="email_mobile" [(ngModel)]="login.email_mobile" #email_mobile="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-email" aria-hidden="true"></i>
                                </span>

                            </div>
                            <div class="wrap-input100 validate-input" data-validate="Password is Incorrect">
                                <input class="input100" type="password" name="password_otp" placeholder="Password/OTP" required id="password_otp" [(ngModel)]="login.password_otp" #password_otp="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-lock" aria-hidden="true"></i>
                                </span>
                            </div>
                            <p class="one_time_password text-danger" (click)="genOtpByMobile()" style="cursor:pointer;margin:0px;margin-top:-5px;font-size: 12px;">
                                CLICK TO GET ONE TIME PASSWORD (OTP)</p>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit" [disabled]="!check_login.form.valid">Login
                                    <span class="symbol-input100 loading-icon" *ngIf="loginLoader">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </button>
                            </div>
                            <div class="text-center p-t-12">
                                <a class="txt2" style="cursor:pointer" (click)="forgotPassword()">Forgot Password ? </a>
                            </div>
                            <div class="formDivider">or use your social accounts to login</div>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn fbLogin" type="button" (click)="facebookLogin()"><i
                                        class="ti-facebook"></i>
                                    Facebook</button>
                                <button class="login100-form-btn glogin" type="button" (click)="googleLogin()"><i
                                        class="ti-google"></i>
                                    Google</button>
                            </div>
                        </form>

                        <!--verify otp-->
                        <form class="login100-form validate-form" name="loginverifyotp" id="loginverifyotp" method="post" (ngSubmit)="matchVerifyOtp()" #loginverifyotp="ngForm" style="position:relative" *ngIf="verifyOtpLoginForm">
                            <div class="loader" *ngIf="verifyotpLoader">
                                <img class="img-fluid" src="assets/images/loader.gif" loading="lazy" alt="loader image">
                            </div>
                            <span class="login100-form-title">Verify</span>
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="verifyErrorMsg"><i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="verifyErrorMsg"></span></p>
                            <p style="font-size: 14px;color:green;font-weight:300;text-align:center" *ngIf="verifySuccessMsg"><i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHTML]="verifySuccessMsg"></span></p>
                            <div class="wrap-input100">
                                <label class="text-center">OTP has been sent to your mobile XXXXXX{{ verifymobile_no }},
                                    please enter same here to verify.</label>
                            </div>
                            <div class="row otpVerify" style="margin: 0;">
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass1" maxlength="1" size="1" required id="pass1" [(ngModel)]="verifyotp.pass1" #pass1="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass2" maxlength="1" size="1" required id="pass2" [(ngModel)]="verifyotp.pass2" #pass2="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass3" maxlength="1" size="1" required id="pass3" [(ngModel)]="verifyotp.pass3" #pass3="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <!-- <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass4" maxlength="1" size="1" required id="pass4" [(ngModel)]="verifyotp.pass4" #pass4="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass5" maxlength="1" size="1" required id="pass5" [(ngModel)]="verifyotp.pass5" #pass5="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass6" maxlength="1" size="1" required id="pass6" [(ngModel)]="verifyotp.pass6" #pass6="ngModel">
                                    <span class="focus-input100"></span>
                                </div> -->
                            </div>
                            <p class="one_time_password text-danger" (click)="resendOtp()" style="cursor:pointer;margin:0px;margin-top:-5px;font-size: 12px;float:right">RESEND (OTP)
                            </p>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit" [disabled]="!loginverifyotp.form.valid">Verify
                                    <span class="symbol-input100 loading-icon" *ngIf="verifyotpLoader">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </button>
                            </div>
                        </form>

                    </div>

                    <!--registration WORK-->

                    <div class="wrap-login100 back">
                        <button type="button" class="close-one" data-dismiss="modal"><i class="ti-close"></i></button>
                        <div>
                            <div class="login100-pic js-tilt" data-tilt>
                                <img src="assets/images/sign-up.webp" loading="lazy" alt="sign-up image">
                            </div>
                            <p>Already registered? <a href="javascript:void(0)" id="loginButton" (click)="resetSignLoginForm()">Login
                                    Now</a></p>
                        </div>
                        <form class="login100-form validate-form" name="submit_registration" id="submit_registration" method="post" (ngSubmit)="userRegistration()" #submit_registration="ngForm" style="position:relative" *ngIf="registrationForm">
                            <div class="loader" *ngIf="registrationLoader">
                                <img class="img-fluid" src="assets/images/loader.gif" loading="lazy" alt="loader image">
                            </div>
                            <span class="login100-form-title">Sign Up</span>
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="regErrorMsg"><i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="regErrorMsg"></span></p>
                            <div class="wrap-input100">
                                <input style="text-transform: capitalize;" class="input100" type="text" name="name" onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || event.charCode == 32)" placeholder="Name"
                                    required id="name" [(ngModel)]="registration.name" #name="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-user" aria-hidden="true"></i>
                                </span>
                                <span class="col-md-12 form-group error-msg" *ngIf="(regSubmitError && name.invalid)">
                                    <p class="error">Enter name</p>
                                </span>
                            </div>
                            <div class="wrap-input100">
                                <input class="input100" type="email" name="email" placeholder="Email" [email]=true required [(ngModel)]="registration.email" #email="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-email" aria-hidden="true"></i>
                                </span>
                                <span class="col-md-12 form-group error-msg" *ngIf="(regSubmitError && email.invalid)">
                                    <p class="error">Enter valid email-id</p>
                                </span>
                            </div>
                            <div class="wrap-input100">
                                <input class="input100" type="password" name="password" placeholder="Password" required [(ngModel)]="registration.password" #password="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-lock" aria-hidden="true"></i>
                                </span>
                                <span class="col-md-12 form-group error-msg" *ngIf="(regSubmitError && password.invalid)">
                                    <p class="error">Enter password</p>
                                </span>
                            </div>
                            <div class="row" style="margin: 0;">
                                <div class="wrap-input100 col-md-4 col-4" style="padding: 0;">
                                    <select class="input100" type="text" name="phone_code" placeholder="IND +91" style="padding: 0 0 0 20px" required [(ngModel)]="registration.phone_code" #phone_code="ngModel">
                                        <option [selected]="registration.phone_code=='91'" value="91">IND +91</option>
                                    </select>
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-8 col-8" style="padding: 0;">
                                    <input class="input100" type="tel" name="mobile" pattern="^\d{10}$" maxLength="10" (keypress)="numberOnly($event)" placeholder="Mobile Number" required [(ngModel)]="registration.mobile" #mobile="ngModel">
                                    <span class="focus-input100"></span>
                                    <span class="symbol-input100">
                                        <i class="ti-mobile" aria-hidden="true"></i>
                                    </span>
                                    <span class="col-md-12 form-group error-msg" *ngIf="(regSubmitError && name.invalid)">
                                        <p class="error">Enter valid Mobile number</p>
                                    </span>
                                </div>
                            </div>
                            <!--
                            <div class="wrap-input100">
                                <input class="input100" type="text" name="pincode" placeholder="Pincode" (keypress)="numberOnly($event,6)" (change)="chkPincode($event)" required  [(ngModel)]="registration.pincode" #pincode="ngModel">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-location-pin" aria-hidden="true"></i>
                                </span>
                                <span class="symbol-input100 loading-icon" *ngIf="pincodeLoader">
                                    <div class="lds-dual-ring"></div>
                                </span>
                            </div>-->
                            <p style="margin:-10px 0px 5px 10px;color:red;text-align: left;font-size:13px" *ngIf="registration.pincode!='' && pincodeMsg!='' && pincodeMsg.error=='1'">
                                {{ pincodeMsg.msg}}</p>
                            <p style="margin:-10px 0px 5px 10px;color:red;text-align: left;font-size:13px" *ngIf="registration.pincode!='' && pincodeMsg!='' && pincodeMsg.error=='0'">
                                {{ pincodeMsg.address}}</p>

                            <div class="row owner-type" style="margin: 0;position:relative">
                                <ul>
                                    <li>
                                        <label for="individual" class="switch">
                                            <input type="radio" name="user_type" id="individual" value="1"
                                                [(ngModel)]="registration.user_type" #user_type="ngModel" required>
                                            <span class="iam round">Individual</span>
                                        </label>
                                    </li>
                                    <!--
                                    <li>
                                        <label for="owner" class="switch">
                                            <input type="radio" name="user_type" id="owner" value="2" [(ngModel)]="registration.user_type" #user_type="ngModel" required>
                                            <span class="iam round">Owner</span>
                                        </label>
                                    </li>
                                    -->
                                    <li>
                                        <label for="broker" class="switch">
                                            <input type="radio" name="user_type" id="broker" value="3"
                                                [(ngModel)]="registration.user_type" #user_type="ngModel" required>
                                            <span class="iam round">Broker/Agent</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label for="Builder" class="switch">
                                            <input type="radio" name="user_type" id="Builder" value="4"
                                                [(ngModel)]="registration.user_type" #user_type="ngModel" required>
                                            <span class="iam round">Builder</span>
                                        </label>
                                    </li>
                                </ul>
                                <span class="col-md-12 form-group error-msg" *ngIf="(regSubmitError && user_type.invalid)">
                                    <p class="error">Select user type</p>
                                </span>
                            </div>
                            <div class="text-center p-t-12 terms-condition">
                                <input type="checkbox" id="agree" name="terms_condition" required [(ngModel)]="registration.terms_condition" #terms_condition="ngModel" />&nbsp;
                                <label class="txt1" for="agree">By clicking below, you agree to &nbsp;</label>
                                <a class="txt2" routerLink="/term-condition">Propira T&amp;C</a>
                                <span class="col-md-12 form-group error-msg" *ngIf="(regSubmitError && terms_condition.invalid)">
                                    <p class="error">Please agree Terms & Conditions</p>
                                </span>
                            </div>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit" *ngIf="submit_registration.form.valid">Sign Up
                                    <span class="symbol-input100 loading-icon" *ngIf="registrationLoader">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </button>
                                <button class="login100-form-btn" (click)="showRegError()" type="button" *ngIf="!submit_registration.form.valid">Sign Up</button>
                            </div>
                        </form>
                        <form class="login100-form validate-form" name="verifyotp" id="verifyOtp" method="post" (ngSubmit)="matchVerifyOtp()" #verifyOtp="ngForm" style="position:relative" *ngIf="verifyOtpForm">
                            <div class="loader" *ngIf="verifyotpLoader">
                                <img class="img-fluid" src="assets/images/loader.gif" loading="lazy" alt="loader image">
                            </div>
                            <span class="login100-form-title">Verify</span>
                            <p style="font-size: 14px;color:#ee8d06;font-weight:300;text-align:center" *ngIf="verifyErrorMsg"><i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="verifyErrorMsg"></span></p>
                            <p style="font-size: 14px;color:green;font-weight:300;text-align:center" *ngIf="verifySuccessMsg"><i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHTML]="verifySuccessMsg"></span></p>
                            <div class="wrap-input100">
                                <label class="text-center">OTP has been sent to your mobile XXXXXX{{ verifymobile_no }},
                                    please enter same here to verify.</label>
                            </div>
                            <div class="row otpVerify" style="margin: 0;">
                                <div class="wrap-input100 col-md-4 col-4" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass1" maxlength="1" size="1" required id="pass1" [(ngModel)]="verifyotp.pass1" #pass1="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-4 col-4" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass2" maxlength="1" size="1" required id="pass2" [(ngModel)]="verifyotp.pass2" #pass2="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-4 col-4" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass3" maxlength="1" size="1" required id="pass3" [(ngModel)]="verifyotp.pass3" #pass3="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <!--<div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass4" maxlength="1" size="1" required id="pass4" [(ngModel)]="verifyotp.pass4" #pass4="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass5" maxlength="1" size="1" required id="pass5" [(ngModel)]="verifyotp.pass5" #pass5="ngModel">
                                    <span class="focus-input100"></span>
                                </div>
                                <div class="wrap-input100 col-md-2 col-2" style="padding: 0;">
                                    <input class="input100 change" type="tel" name="pass6" maxlength="1" size="1" required id="pass6" [(ngModel)]="verifyotp.pass6" #pass6="ngModel">
                                    <span class="focus-input100"></span>
                                </div> -->
                            </div>
                            <p class="one_time_password text-danger" (click)="resendOtp()" style="cursor:pointer;margin:0px;margin-top:-5px;font-size: 12px;float:right">RESEND (OTP)
                            </p>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit" [disabled]="!verifyOtp.form.valid">Verify
                                    <span class="symbol-input100 loading-icon" *ngIf="verifyotpLoader">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="loader">
    <div style="align-items: center;width:100%;height:100%;display: flex;justify-content: center;">
        <img class="img-fluid" src="assets/images/loader.gif" loading="lazy" alt="loader image">
    </div>
</div>



<!-- <a class="nav-link  mobile-post" style="cursor:pointer" routerLink="/quick-listing"><i class="ti-pencil-alt"></i> Post
    Your Property
    <span class="menu-offer">FREE</span>
</a> -->

<div class="responsive-menus-menu" style="left:-110%">
    <nav class="navbar navbar-expand-sm bg-light">
        <div class="col-md-12 close-btnn">
            <a href="javascript:void(0)" (click)="onToggle()"><i class="ti-close">
                <!-- <img src="assets/images/msite-header-footer.png" alt=""> -->
            </i>
            </a>
        </div>
        <div class="col-md-12 for-logins" *ngIf="!isLoggedIn()">
            <strong>Sign in to get a personalised feed!</strong> <a href="javascript:void(0)" (click)="resetSignLoginForm();openLoginWindow()"><i class="ti-user" style="margin-right: 5px;"></i>
                Login</a>
        </div>
        <div class="col-md-12 for-logins new-type" *ngIf="isLoggedIn()">
            <!--<span>{{ profileDetail.name.charAt(0) }}</span> -->
            <span><img src="{{ profileDetail.image }}"
                    style="height: 100%;width: 100%;object-fit: unset;border-radius: 50%;" /></span>
            <span>{{ profileDetail.name }} <span routerLink="/profile" (click)="onToggle()" routerLink="/profile"
                    style="cursor:pointer"> View Profile </span></span>
        </div>
        <ul *ngIf="isLoggedIn()">
            <li><a (click)="onToggle()" routerLink="/">Home</a></li>
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a itemprop="url" (click)="onToggle()" routerLink='/quick-listing'><span itemprop="name">Post Your
                        Property</span></a>
            </li>
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a an-id="0" an-city="0" an-val="Read Home Tips" an-sec="Menu" an-cat="HM" an-act="click" an-device="M" class="an-nps-menu-click" itemprop="url" (click)="onToggle()" routerLink='/profile/shortlist'>
                    <span itemprop="name">Shortlisted Properties</span>
                </a>
            </li>
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a an-id="0" an-city="0" an-val="Explore design ideas" an-sec="Menu" an-cat="HM" an-act="click" an-device="M" class="an-nps-menu-click" itemprop="url" (click)="onToggle()" routerLink='/profile/myproperty'>
                    <span itemprop="name">My Properties</span>
                </a>
            </li>
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a itemprop="url" (click)="onToggle()" routerLink='/profile/set-alerts'><span itemprop="name">Enter your
                        requirement</span></a>
            </li>
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a itemprop="url" (click)="onToggle()" routerLink='/profile/notification'><span
                        itemprop="name">Notifications</span></a>
            </li>
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a itemprop="url" (click)="onToggle()" routerLink='/profile/change-password'><span
                        itemprop="name">Change Password</span></a>
            </li>
            <li><a (click)="logout();onToggle()" style="cursor:pointer">Logout</a></li>
        </ul>

        <ul *ngIf="!isLoggedIn()">
            <li><a (click)="onToggle()" routerLink="/">Home</a></li>
            <!-- <li><a (click)="onToggle()" routerLink="/vastu-services">Facilities for Property</a></li> -->
            <li itemscope="" itemtype="https://schema.org/SiteNavigationElement">
                <a itemprop="url" (click)="onToggle()" routerLink='/quick-listing'><span itemprop="name">Post Your
                        Property</span></a>
            </li>
        </ul>

        <div class="post--property mp-15">
            <a an-id="0" an-city="" an-val="Post Property" an-sec="Menu" an-cat="WH" an-act="click" an-device="M" href="#" class="property--btn an-nps-menu-click">Post Property <span>Free</span></a>
            <p>Get more out of your property!</p>

        </div>
    </nav>
</div>